import { gql, useQuery } from '@apollo/client';

const GET_COOKIE_RADAR_HEALTH = gql`
  query GetCookieRadarHealth {
    getCookieRadarHealth {
      available
    }
  }
`;

interface CookieRadarHealth {
  available: boolean;
}

interface CookieRadarHealthQueryResult {
  getCookieRadarHealth: CookieRadarHealth;
}

export function useCookieRadarHealthQuery() {
  return useQuery<CookieRadarHealthQueryResult>(GET_COOKIE_RADAR_HEALTH, {
    fetchPolicy: 'network-only',
  });
}
